import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-the-page-m03__form c-form-inner" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "p-the-page-m03__consent__checkbox" }
const _hoisted_4 = { class: "p-form-button-group" }
const _hoisted_5 = { class: "p-form-button-group__vertical" }
const _hoisted_6 = { class: "p-form-button-group__vertical" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputCheckBox = _resolveComponent("InputCheckBox")!
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_FormConsent = _resolveComponent("FormConsent")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_ValidationObserver = _resolveComponent("ValidationObserver")!
  const _component_TheTemplateM = _resolveComponent("TheTemplateM")!

  return (_openBlock(), _createBlock(_component_TheTemplateM, { class: "p-the-page-m03" }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ValidationObserver, { slim: "" }, {
          default: _withCtx((ObserverProps) => [
            _createElementVNode("form", {
              ref: "form",
              action: "/profile-update/",
              method: "post",
              onSubmit: _withModifiers(($event: any) => (_ctx.submit(ObserverProps)), ["prevent"])
            }, [
              _createVNode(_component_FormConsent, {
                class: "p-the-page-m03__consent",
                onLinkClicked: _ctx.enableCheckbox
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ValidationProvider, { rules: "consentRequired" }, {
                    default: _withCtx((ProviderProps) => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_InputCheckBox, {
                          modelValue: _ctx.consent,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.consent) = $event)),
                          disabled: _ctx.ischeckBoxDisabled,
                          name: "consent",
                          error: ProviderProps.errors[0],
                          onChecked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCheckConsent()))
                        }, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createTextVNode("利用規約に同意する", -1)
                          ])),
                          _: 2,
                          __: [3]
                        }, 1032, ["modelValue", "disabled", "error"])
                      ])
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.consent_time) = $event)),
                    type: "hidden",
                    name: "consent_time"
                  }, null, 512), [
                    [_vModelText, _ctx.consent_time]
                  ])
                ]),
                _: 1
              }, 8, ["onLinkClicked"]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_ButtonMain, {
                    type: "submit",
                    disabled: ObserverProps.invalid,
                    onClickButton: _ctx.submitPage
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode("同意して進む", -1)
                    ])),
                    _: 2,
                    __: [4]
                  }, 1032, ["disabled", "onClickButton"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_ButtonMain, {
                    tag: 'a',
                    href: "/my-page/",
                    kind: 'cancel'
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("キャンセル", -1)
                    ])),
                    _: 1,
                    __: [5]
                  })
                ])
              ])
            ], 40, _hoisted_2)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}